import { fork, takeEvery, all } from 'redux-saga/effects';
import {
  BaseResponse,
  SystemApi, SystemControllerDtoApiRoleDeleteRequest,
  SystemControllerDtoApiRoleListRequest, SystemControllerDtoApiRoleUpdateRequest,
  SystemControllerDtoGroupRoleCategoryListRequest,
  SystemControllerDtoGroupRoleUpdateRequest,
} from '../../models/src';
import config from '../../../config/config';
import {
  GROUP_ROLE_CATE_LIST_REQUEST,
  GROUP_ROLE_UPDATE_REQUEST,
  SYSTEM_API_ROEL_DELETE_REQUEST,
  SYSTEM_API_ROEL_UPDATE_REQUEST,
  SYSTEM_API_ROLE_LIST_REQUEST,
} from '../../constants/backoffice/systemConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import SystemControllerDtoGroupRoleCategoryListResponse
  from '../../models/src/model/SystemControllerDtoGroupRoleCategoryListResponse';
import SystemControllerDtoApiRoleListResponse from '../../models/src/model/SystemControllerDtoApiRoleListResponse';

const api = new SystemApi(config.API_CLIENT);

//= ====================================
//  WATCHERS
//-------------------------------------

function* getGroupRoleCategoryList(payload) {
  try {
    const req = new SystemControllerDtoGroupRoleCategoryListRequest();
    req.groupNo = payload.groupNo;
    const result = yield api.apiSystemGroupRoleCategoryListPost(
      { systemControllerDtoGroupRoleCategoryListRequest: req },
      () => {},
    );
    const data = api.apiClient.deserialize(result, SystemControllerDtoGroupRoleCategoryListResponse);
    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    if (payload.callback) {
      payload.callback(data);
    }
  } catch (e) {
    payload.error(e);
  }
}

function* updateGroupRole(payload) {
  try {
    const req = new SystemControllerDtoGroupRoleUpdateRequest();
    req.list = payload.data?.list || [];
    const result = yield api.apiSystemGroupRoleUpdatePost(
      { systemControllerDtoGroupRoleUpdateRequest: req },
      () => {},
    );
    const data = api.apiClient.deserialize(result, BaseResponse);
    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    payload.error(e);
  }
}

function* systemApiRoleListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SystemControllerDtoApiRoleListRequest();
    requestData.gnbNo = payload.gnbNo;
    requestData.lnbNo = payload.lnbNo;
    requestData.subNo = payload.subNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemApiRoleListPost({ systemControllerDtoApiRoleListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, SystemControllerDtoApiRoleListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* systemApiRoleUpdateRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SystemControllerDtoApiRoleUpdateRequest();
    requestData.apiUrl = payload.apiUrl;
    requestData.gnbNo = payload.gnbNo;
    requestData.lnbNo = payload.lnbNo;
    requestData.subNo = payload.subNo;
    requestData.dontReadonly = payload.dontReadonly;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemApiRoleUpdatePost({ systemControllerDtoApiRoleUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* systemApiRoleDeleteRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SystemControllerDtoApiRoleDeleteRequest();
    requestData.apiUrl = payload.apiUrl;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemApiRoleDeletePost({ systemControllerDtoApiRoleDeleteRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* systemRootSaga() {
  yield all([
    takeEvery(GROUP_ROLE_CATE_LIST_REQUEST, getGroupRoleCategoryList),
    takeEvery(GROUP_ROLE_UPDATE_REQUEST, updateGroupRole),
    takeEvery(SYSTEM_API_ROLE_LIST_REQUEST, systemApiRoleListRequestSaga),
    takeEvery(SYSTEM_API_ROEL_UPDATE_REQUEST, systemApiRoleUpdateRequestSaga),
    takeEvery(SYSTEM_API_ROEL_DELETE_REQUEST, systemApiRoleDeleteRequestSaga),
  ]);
}

const systemSagas = [fork(systemRootSaga)];

export default systemSagas;
